module.exports = __webpack_public_path__ + "img/openpbb2024-4.66580ee3.png";